import { cn } from '../../@/lib/utils'
import { useGlobalContext } from '../../common/hooks/useGlobalContext'
import { SimpleProject } from '../../common/hooks/useOrgProjects'
import { ProjectAvatar } from './ProjectAvatar'

export function CompanyLogo({ small, project }: { small?: boolean; project?: SimpleProject }) {
  const { user } = useGlobalContext()
  const logoUrl = user?.organizationLogo?.storageUrl
  const size = small ? 'h-5 w-5' : 'h-6 w-6'

  if (!logoUrl) {
    return <ProjectAvatar project={project} small={small} />
  }

  return (
    <div className={cn('relative overflow-hidden rounded', size)}>
      <div
        className={cn('absolute top-0 start-0 blur brightness-125', size)}
        style={{
          backgroundImage: `url(${logoUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      ></div>
      <div
        className={cn('absolute top-0 start-0 z-10', size)}
        style={{
          backgroundImage: `url(${logoUrl})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      />
    </div>
  )
}
